import { render } from "./AposTiptapInsertItem.vue?vue&type=template&id=6131ca1e"
import script from "./AposTiptapInsertItem.vue?vue&type=script&setup=true&lang=js"
export * from "./AposTiptapInsertItem.vue?vue&type=script&setup=true&lang=js"

import "./AposTiptapInsertItem.vue?vue&type=style&index=0&id=6131ca1e&lang=scss"

import exportComponent from "../../../../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"rich-text-widget/ui/apos/components/AposTiptapInsertItem.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6131ca1e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6131ca1e', __exports__)) {
    api.reload('6131ca1e', __exports__)
  }
  
  module.hot.accept("./AposTiptapInsertItem.vue?vue&type=template&id=6131ca1e", () => {
    api.rerender('6131ca1e', render)
  })

}


export default __exports__